import helper from './helper'

export default {
  async getJobResult(jobId) {
    return await helper.get(`/api/hybrik/get-result/${jobId}`)
  },
  async getAll() {
    return await helper.get(`/api/hybrik/get-all`)
  },
  async qcOverride(id) {
    return await helper.get(`/api/hybrik/qc-override/${id}`)
  }
}
